import { DateTime } from "./luxon.js";

const STATIC_SELECTORS = {
  date: "[data-estimate-delivery-date-text]",
};

const HOLIDAY_DATE = /^\d{4}-\d{2}-\d{2}$/;

const SHIP_DATE_FORMAT = { weekday: "short", month: "short", day: "numeric" };

export class EstimateDeliveryDate extends HTMLElement {
  connectedCallback() {
    this.cutoffHour = Number(this.dataset.cutoffHour);
    this.warehouseTimezone = this.dataset.warehouseTimezone || "";
    this.locale = this.dataset.locale || document.documentElement.lang || "en";
    this.holidays = new Set(
      (this.dataset.holidays || "")
        .split(/[\s,]+/)
        .map((date) => date.replace(/\//g, "-"))
        .filter((date) => HOLIDAY_DATE.test(date))
    );

    const dateElement = this.querySelector(STATIC_SELECTORS.date);

    if (
      !dateElement ||
      !this.warehouseTimezone ||
      !Number.isFinite(this.cutoffHour)
    ) {
      return;
    }

    dateElement.textContent = this.formatShipDate(this.getShipDate());
  }

  getShipDate() {
    const now = DateTime.now().setZone(this.warehouseTimezone);
    let shipDay = now.startOf("day");
    const todaysCutoff = shipDay.set({
      hour: this.cutoffHour,
      minute: 0,
      second: 0,
      millisecond: 0,
    });

    if (!this.isShippingDay(shipDay) || now >= todaysCutoff) {
      do {
        shipDay = shipDay.plus({ days: 1 }).startOf("day");
      } while (!this.isShippingDay(shipDay));
    }

    return shipDay;
  }

  formatShipDate(dateTime) {
    try {
      return dateTime.setLocale(this.locale).toLocaleString(SHIP_DATE_FORMAT);
    } catch {
      return dateTime.setLocale("en").toLocaleString(SHIP_DATE_FORMAT);
    }
  }

  isBusinessDay(dateTime) {
    return dateTime.weekday >= 1 && dateTime.weekday <= 5;
  }

  isShippingDay(dateTime) {
    return this.isBusinessDay(dateTime) && !this.isHoliday(dateTime);
  }

  isHoliday(dateTime) {
    return this.holidays.has(dateTime.toISODate());
  }

}

if (!customElements.get("estimate-delivery-date")) {
  customElements.define("estimate-delivery-date", EstimateDeliveryDate);
}
